import { render } from "./LbrxInfoValidation.vue?vue&type=template&id=f2fb8618"
import script from "./LbrxInfoValidation.vue?vue&type=script&lang=js"
export * from "./LbrxInfoValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__